import { PriceDesc } from './PriceDesc';
import { sprinkles } from '@design-system/sprinkles.css';
import { clsx } from 'clsx';
import { Typography } from '@design-system/components/typography/typography';
import { Avatar } from '@mui/material';

export type ProgramCardProps = {
  title: string;
  subtitle: string;
  thumbnailUrl: string;
  price: string;
  discountedPrice: string | null;
};
export const ProgramCard = (p: ProgramCardProps) => (
  <div className={clsx('flex flex-col justify-center items-center')}>
    <div
      className={clsx(
        'flex flex-col items-center gap-6 p-4 w-[216px] rounded-[10px]',
        sprinkles({ bg: 'N-10' }),
      )}
    >
      <Avatar
        alt="thumbnail"
        src={p.thumbnailUrl}
        className={clsx(
          'w-[100px] h-[100px] border-[1.5px]',
          sprinkles({ borderColor: 'P-80' }),
        )}
      />
      <div className="flex flex-col items-center gap-2">
        <Typography variant="title">{p.title}</Typography>
        <Typography variant="body" size="large" fontWeight="normal">
          {p.subtitle}
        </Typography>
        {!p?.price ? null : (
          <PriceDesc price={p.price} discountedPrice={p.discountedPrice} />
        )}
      </div>
    </div>
  </div>
);
